export default "__VITE_ASSET__70a8a68c__"